<template>
  <div class="container">
    <section class="page_404">
      <div class="four_zero_four_bg">
        <h1 class="text-center">404</h1>
      </div>
      <div class="contant_box_404">
        <h3 class="h2">Look like you're lost</h3>
        <p>The page you are looking for is not available!</p>
        <router-link :to="{ name: 'Dashboard' }" class="link_404">Go to Home</router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'pageNotFound'
}
</script>

<style scoped>
/* Reset body styles */
.page_404 {
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  text-align: center;
  font-family: "Arvo", serif;
}

.four_zero_four_bg {
  background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);
  height: 50vh;
  width: 100%;
  background-position: center;
  background-size: cover;
}

.four_zero_four_bg h1 {
  font-size: 100px;
  color: #fff;
}

.link_404 {
  color: #f9f9f9 !important;
  padding: 10px 20px;
  background: #39ac31;
  text-decoration: none;
  display: inline-block;
  margin-top: 20px;
  font-size: 18px;
  border-radius: 5px;
}
.page_404 h1{
  color: #2c3e50;
}
</style>
